import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { NotificationPermissionDialogComponent } from '../notifications/notification-permission-dialog.component';
import { ModalUtilsService } from './modal-utils.service';

@Injectable({ providedIn: 'root' })
export class NotificationPermissionService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly modalUtils = inject(ModalUtilsService);

  promptIfNeeded() {
    if (!isPlatformBrowser(this.platformId)) return undefined;

    try {
      if (!('Notification' in window)) return undefined;
      const alreadyPrompted = localStorage.getItem('notif_prompted') === '1';
      if (alreadyPrompted) return undefined;
      if (Notification.permission !== 'default') return undefined;

      const ref = this.modalUtils.openModal(
        NotificationPermissionDialogComponent,
        {
          backdrop: 'static',
          keyboard: false,
        }
      );

      // No need to handle result; dialog will persist the flag
      return ref;
    } catch {
      return undefined;
    }
  }
}
